import React, { ErrorInfo } from 'react';
import { createRoot } from 'react-dom/client';
import Application from './components/Application';
import ErrorBoundary from './components/shared/ErrorBoundary';

// Say something
console.log('[Ovation] : Renderer execution started');

const handleCriticalError = (error: Error, errorInfo: ErrorInfo) => {
    console.error("Critical error caught:", error, errorInfo);
};

if (document.getElementById('app')) {
    // Wrap Application in ErrorBoundary
    const app = (
        <ErrorBoundary onCriticalError={handleCriticalError}>
            <Application />
        </ErrorBoundary>
    );

    // Render application in DOM
    createRoot(document.getElementById('app')).render(app);
}
